var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"journal-icon",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.6","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":_vm.paths[_vm.name] || _vm.paths.pokedex}})])
}
var staticRenderFns = []

export { render, staticRenderFns }